const titles = {
  'en-US': {title: 'English'},
  'de-DE': {title: 'Deutsch'},
  'es-ES': {title: 'Español'},
  'fr-FR': {title: 'Français'},
  'ja-JP': {title: '日本'},
  'cs-CZ': {title: 'Čeština'},
  'pl-PL': {title: 'Polski'},
  'pt-BR': {title: 'Português'},
  'it-IT': {title: 'Italiano'},
  'uk-UA': {title: 'Українська'},
  'ru-RU': {title: 'Русский'},
  'he-IL': {title: 'עברית'},
  'ko-KR': {title: '한국어'},
  'hu-HU': {title: 'Magyar'},
  'zh-CN': {title: '中文（中国）'},
  'tr-TR': {title: 'Türkçe'}
};

export default function ConvertLocales(locales) {
  // eslint-disable-next-line no-param-reassign
  locales = locales || [];
  return locales.map(locale => ({
    key: locale.locale,
    isCommunity: locale.isCommunity,
    label: titles[locale.locale] ? titles[locale.locale].title : locale.locale
  }));
}



// WEBPACK FOOTER //
// ./src/blocks/locales/locales.js